import { createAsyncThunk } from '@reduxjs/toolkit';
import type { OtherPlayerResponse, ProfileResponse } from '../api/profile.types';
import { axiosInstance } from '@/shared/api/instance';

export const fetchProfile = createAsyncThunk('profile/fetchProfile', async (_, thunkAPI) => {
  try {
    const response = await axiosInstance.get<ProfileResponse>('/app/profile/get');
    return response.data;
  } catch (error: any) {
    return thunkAPI.rejectWithValue(error.message || 'Ошибка при загрузке профиля');
  }
});

export const updateProfile = createAsyncThunk(
  'profile/updateProfile',
  async (
    updateData: {
      realName: string;
      gameName: string;
      gender: 'MALE' | 'FEMALE';
      clubId: string;
      base64Photo?: string;
      removePhoto?: boolean;
    },
    thunkAPI,
  ) => {
    try {
      console.log('Отправляемые данные:', updateData);
      const response = await axiosInstance.post('/app/profile/update', updateData, {
        headers: {
          'Content-Type': 'application/json',
        },
      });
      return response.data;
    } catch (error: any) {
      const errorMessage = error.response?.data?.message || 'Ошибка при обновлении профиля';
      return thunkAPI.rejectWithValue({
        message: errorMessage,
        status: error.response?.status,
        statusText: error.response?.statusText,
        data: error.response?.data,
        originalError: error,
      });
    }
  },
);

export const fetchOtherPlayer = createAsyncThunk(
  'profile/fetchOtherPlayer',
  async (playerId: string, thunkAPI) => {
    try {
      const response = await axiosInstance.get<OtherPlayerResponse>('/app/players/get', {
        params: { id: playerId },
      });
      return response.data;
    } catch (error: any) {
      let errorMessage = 'Ошибка при загрузке данных игрока';
      if (error.response) {
        errorMessage = error.response.data.message || errorMessage;
      }
      return thunkAPI.rejectWithValue(errorMessage);
    }
  },
);
